var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1500 289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-588.801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2.39275,589.885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-40.627,227.884L-41.164,228.237L-41.066,228.873L-27.522,316.653L-27.266,318.314L-25.928,317.296L72.063,242.722L72.07,242.717C101.078,220.29 144.535,186.692 196.433,157.797C248.337,128.9 308.618,104.745 371.259,101.151C433.208,97.596 497.549,114.137 562.106,130.966L564.417,131.569C628.122,148.179 692.008,164.836 753.667,162.226L753.934,162.242C816.98,166.03 879.978,148.983 942.832,128.213C956.824,123.59 970.807,118.782 984.783,113.978C1033.65,97.178 1082.43,80.409 1131.22,71.614C1256.67,49.002 1382.16,79.15 1445.01,94.256L1445.03,94.26L1544.63,116.001L1545.95,116.29L1545.84,114.941L1538.52,26.796L1538.45,26.001L1537.66,25.889L1436.73,11.608L1436.72,11.606L1436.71,11.605L1436.67,11.6C1372.5,3.957 1243.99,-11.35 1121.61,25.922C1074.01,40.418 1027.33,62.873 980.735,85.289C967.436,91.687 954.143,98.082 940.837,104.288C880.856,132.262 820.572,156.417 757.926,160.012C756.514,160.093 755.1,160.163 753.685,160.224C691.124,156.384 628.529,131.938 565.748,107.421L565.675,107.392C502.92,82.884 439.981,58.313 377.007,54.529C313.956,50.741 250.955,67.788 195.897,90.471C140.842,113.153 93.659,141.502 62.239,160.379L62.206,160.399L62.186,160.412L62.186,160.412L-40.627,227.884Z",
    style: {
      fill: "rgb(229,244,247)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,750,733.301)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-756,-144.5)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1512,
    height: 289
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-32.934,284.959L29.239,238.432C91.411,191.905 215.756,98.851 349.011,93.328C482.265,87.804 624.429,169.811 757.683,164.288C890.937,158.765 1015.28,65.711 1145.3,28.358C1275.31,-8.994 1411,9.354 1478.84,18.528L1546.68,27.703",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(126,202,214)",
      strokeOpacity: 0.5,
      strokeWidth: 10
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,2.75521,0,-990.348)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 359.446,
    width: 1500,
    height: 104.892,
    style: {
      fill: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgWelcome);
export default __webpack_public_path__ + "static/media/bg-welcome.71dcc1aeddd4c8d385177ec82d50c8f8.svg";
export { ForwardRef as ReactComponent };